// extracted by mini-css-extract-plugin
export default {"loading":"planUsageTab_loading__iRL8A"};